export enum C4CFormTypes {
  YENI_REZERVASYON = 'YeniRezervasyon',
  MEVCUT_REZERVASYON = 'MevcutRezervasyon',
  ONERI = 'Oneri',
  SIKAYET = 'Sikayet',
  TESEKKUR = 'Tesekkur',
  TEDARIKCI_DESTEK = 'TedarikciDestek',
  INSAN_KAYNAKLARI = 'InsanKaynaklari',
  DUTY_FREE = 'DutyFree',
}
